export var ItemHover = (window.ItemHover = new Class({
   initialize: function(li) {
      this.li = li;
      this.featured = li.hasClass('featured');
      this.name = li.getElement('.itemName').get('text');
      this.isForSale = li.getProperty('data-is-for-sale') !== null;
      this.isFromExternalSupplier = li.getProperty('data-external-supplier') !== null;
      this.subtitleText = li.getProperty('data-subtitle-text');
      this.subtitleClass = li.getProperty('data-subtitle-class');
      this.guideinfo = li.getProperty('data-guideinfo');

      this.supplier = li.getProperty('data-supplier');
      this.imageURL = li.getProperty('data-image');
      this.purchaseURL = li.getProperty('data-purchaseUrl');
      this.wikiURL = li.getProperty('data-wikiUrl');
      this.editURL = li.getProperty('data-editUrl');
      this.text = li.getProperty('data-text');
      this.onPrivateSite = li.getProperty('data-private') == 1;
      this.tooltipClass = li.getProperty('data-tooltip-class') || 'itemHover';
      this.infoButtonClass = li.getProperty('data-info-button-class') || '';
      this.buyButtonClass = li.getProperty('data-buy-button-class') || '';
      this.tip = this.buildTooltip();

      li.addEvents({
         mouseenter: li.addClass.pass('active', li),
         mouseleave: li.removeClass.pass('active', li),
      });
   },

   buildTooltip: function() {
      var content = new Element('div.' + this.tooltipClass);
      var link;
      var priceEl;

      link = this.purchaseURL || this.wikiURL;

      if (this.imageURL) {
         content.addClass('hasImage');
         content.adopt(
            new Element('div.thumbnail').adopt(
               new Element('a', {
                  href: link,
                  styles: {
                     backgroundImage: 'url(' + this.imageURL + ')',
                  },
               })
            )
         );
      }

      content.adopt(
         new Element('h3.title').adopt(
            new Element('a', {
               href: link,
               text: this.name,
            })
         )
      );

      var buyNowText = _js('Buy Now');
      if (!this.isForSale) {
         buyNowText = _js('View Item');
      } else if (this.isFromExternalSupplier && this.supplier) {
         /* Translators: %1 -> Supplier; */
         buyNowText = _js('Buy on %1', this.supplier);
      }

      content.adopt(
         (priceEl = new Element('p', {
            text: this.subtitleText,
            class: this.subtitleClass,
         }))
      );

      content.adopt(
         new Element('p.guideinfo', {
            text: this.guideinfo,
         })
      );

      var text = _js(
         "This {item} doesn't have a description yet, but you can help! {a1}Improve the {name} wiki{a2} with a quick explanation."
      );
      content.adopt(
         new Element('p.description', {
            html:
               htmlEncode(this.text) ||
               text.substitute({
                  item: this.li.getParent('ul').getProperty('data-itemType'),
                  name: htmlEncode(this.li.getElement('.itemName').get('text')),
                  a1: '<a target="_blank" href="' + this.editURL + '">',
                  a2: '</a>',
               }),
         })
      );

      content.adopt(new Element('div.clearer'));

      if (this.purchaseURL) {
         content.adopt(
            new Element('p.purchaseLink').adopt(
               new Element('a', {
                  text: buyNowText,
                  target: '_blank',
                  href: this.purchaseURL,
                  class: this.buyButtonClass,
               })
            )
         );
      }

      if (this.wikiURL && this.text) {
         content.adopt(
            new Element('p.wikiLink').adopt(
               new Element('a', {
                  text: _js('Info'),
                  target: '_blank',
                  href: this.wikiURL,
                  class: this.infoButtonClass,
               })
            )
         );
      }

      content.adopt(new Element('div.clearer'));

      var nudge, offset, arrowInset;
      if (this.featured) {
         nudge = 13;
         offset = -10;
         arrowInset = 16;
      } else {
         nudge = 24;
         offset = -7;
         arrowInset = 32;
      }

      var tip = new Tooltip(this.li, {
         autoshow: true,
         showDelay: 400,
         side: 'top',
         arrowAlign: 'left',
         offset: offset,
         nudge: nudge,
         arrowInset: arrowInset,
         text: content,
         maxWidth: 300,
      });

      return tip;
   },
}));
